import {createAction, props} from '@ngrx/store';
import {VarianteTypeEntity} from '../../entities/varianteType.entity';

export const VarianteTypesActionTypes = {
    UpdateVarianteTypes: createAction(
        'data/varianteTypes/update',
        props<{Payload: Array<VarianteTypeEntity>}>()
    )
};
